// extracted by mini-css-extract-plugin
module.exports = {"ValidOfferModal":"ValidOffer_ValidOfferModal__3wNk3"};